var React = require('react');

function Card (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 7"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Web","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"style-guide2","transform":"translate(-824.000000, -4426.000000)","stroke":"currentColor"},React.createElement("g",{"id":"Group-7","transform":"translate(826.000000, 4428.000000)"},[React.createElement("rect",{"id":"Rectangle-path","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","x":"-7.28306304e-13","y":"1.82076576e-13","width":"16.1","height":"11.1","rx":"2","key":0}),React.createElement("path",{"d":"M0.314014933,3.93960524 L16.099119,3.93960524","id":"Path-2","strokeWidth":"2","key":1})])))]);
}

Card.defaultProps = {"width":"20px","height":"15px","viewBox":"0 0 20 15","version":"1.1"};

module.exports = Card;

Card.default = Card;
